/* eslint-disable camelcase */
import {
  Recommendation,
  RecommendationCardEnum,
  RecommendationCardType,
} from '@/api/rest/resources/types/recommendations';
import { RecommendationCard } from '@/components/widgets/o/RecommendationCard/types';

export const parseRecommendation = (recommendation: Recommendation): RecommendationCard => {
  const { id, recommendation_data, next } = recommendation;
  const {
    body,
    pill,
    header,
    footer_text,
    footer_value,
    body_expanded,
    recommendation_type,
    planning,
    affected_assets,
  } = recommendation_data;

  const recommendationType = recommendation_type as RecommendationCardType;

  if (!recommendationType || !RecommendationCardEnum[`${recommendationType}`]) {
    throw new Error(`Invalid recommendation type: ${recommendation_type}`);
  }

  return {
    id,
    type: recommendationType,
    header: header ? { text: header } : undefined,
    body: {
      collapsed: body ? { text: body } : undefined,
      expanded: {
        header: body_expanded?.title,
        text: body_expanded?.body,
        // TODO: BE currently only supports a single plan, but this is meant to be an array according to the designs. When BE supports multiple plans, this should be updated.
        planning: [
          {
            title: planning?.plan_header,
            text: planning?.plan_body,
            footer: {
              text: planning?.plan_footer_text,
              value: planning?.plan_footer_value,
            },
          },
        ].filter((plan) => plan.title || plan.text || plan.footer?.text || plan.footer?.value),
        isDismisable: false, // TODO: this feature currently lacks of functionality
      },
    },
    footer: {
      text: footer_text || undefined,
      value: footer_value || undefined,
    },
    pill: {
      ...parseTextOrI18nPath(pill, recommendationType, 'global.widget.recommendationCard.type'),
      showMarker: recommendationType === RecommendationCardEnum.monetization,
    },
    affected_assets,
    next,
  };
};

export const parseTextOrI18nPath = (
  textInput: string | undefined,
  recommendationType: RecommendationCardType,
  fallbackI18Path: string,
) => {
  if (textInput) {
    return {
      text: textInput,
    };
  }

  if (recommendationType === RecommendationCardEnum.custom) {
    return {};
  }

  return {
    i18nPath: `${fallbackI18Path}.${recommendationType}`,
  };
};
